/*

Sainapse® incorporates patented, and “patent pending”, technology.

© 2017 - 2024 Sainapse Inc. and its licensors. All rights reserved worldwide.

Sainapse Inc. and its licensors own all rights in this work, including but not limited to the source code, algorithms, text, 
flowcharts and images herein, which are protected by copyright laws in applicable jurisdictions. Any use of this work is permissible 
only with an express written license or authorization from Sainapse Inc., and only to the extent and for the purpose permitted. 
Unauthorized copying, editing, reproduction, redistribution, modification, creation of derivative works, translation, adaptation, 
customization, decompilation, reverse engineering, disassembling or hacking of this work or any part thereof, including but not limited to the source code, 
header files and libraries of the software, via any medium is strictly prohibited.

Open Source Software that is provided as part of Sainapse® is subject to and governed solely by the terms and conditions of the applicable open source license agreements, 
and their respective terms, conditions, restrictions and obligations, a copy of which will be made available to you upon request.

Proprietary and Confidential. Sainapse® and associated documentation is the property of Sainapse Inc. and considered confidential information. 
No part of it may be disclosed without the express written consent of Sainapse Inc.Please note that any infringement or violation will invite legal action, 
both civil and criminal, as appropriate, without any further notice.

*/
let components = [
    {
        type : "text",
        annotation : "Text Input",
        value_type : "text",
        component_params : [
            {
                name : "place_holder",
                value_type : "text",
                mandatory : false
            },
            {
                name : "error",
                value_type : "boolean",
                mandatory : false
            },
            {
                name : "error_messsage",
                value_type : "text",
                mandatory : false
            },
            {
                name : "helper_text",
                value_type : "text",
                mandatory : false
            },
            {
                name : "mandatory",
                value_type : "boolean",
                mandatory : false
            },
            {
                name : "width",
                value_type : "number",
                mandatory : false
            },
            {
                name : "multi_line",
                value_type : "boolean",
                mandatory : false
            },
            {
                name : "max_rows",
                value_type : "number",
                mandatory : false
            },
            {
                name : "auto_paste",
                value_type : "boolean",
                mandatory : false
            },
            {
                name : "copy_content",
                value_type : "boolean",
                mandatory : false
            },
            {
                name : "accept_attachment",
                value_type : "boolean",
                mandatory : false
            },
            {
                name : "embed_attachment",
                value_type : "boolean",
                mandatory : false
            },
            {
                name : "binding_key",
                value_type : "text",
                mandatory : true
            }
        ],
        setup_form : [
            {
                name : "binding_key",
                value : {
                    number: null,
                    text: null,
                    list: null,
                    boolean: null
                },
                elements: null,
                component: "select",
                component_params : [
                    {
                        name : "width",
                        value : {
                            text : null,
                            number : 50,
                            boolean : null,
                            list : null
                        }
                    },
                    {
                        name: "helper_text",
                        value: {
                            number: null,
                            text: "Select the field in scope you want to bind to.",
                            list: null,
                            boolean: null
                        }
                    },
                    {
                        name : "options",
                        value: {
                            number: null,
                            text: null,
                            list: ["$fieldsInScope"],
                            boolean: null
                        }
                    }
                ]
            },
            {
                name: "width",
                value: {
                  number: 50,
                  text: null,
                  list: null,
                  boolean: null
                },
                elements: null,
                component: "slider",
                component_params: [
                    {
                        name : "width",
                        value : {
                            text : null,
                            number : 50,
                            boolean : null,
                            list : null
                        }
                    },
                    {
                        name: "min_value",
                        value: {
                          number: 0,
                          text: null,
                          list: null,
                          boolean: null
                        }
                    },
                    {
                        name: "max_value",
                        value: {
                          number: 100,
                          text: null,
                          list: null,
                          boolean: null
                        }
                    },
                    {
                        name: "step_size",
                        value: {
                          number: 1,
                          text: null,
                          list: null,
                          boolean: null
                        }
                    }
                ],
            },
            {
                name: "place_holder",
                value: {
                  number: null,
                  text: null,
                  list: null,
                  boolean: null
                },
                elements: null,
                component: "text",
                component_params: [
                    {
                        name : "helper_text",
                        value : {
                            text : "Please add a placeholder",
                            number : null,
                            boolean : null,
                            list : null
                        }
                    },
                    {
                        name : "width",
                        value : {
                            text : null,
                            number : 50,
                            boolean : null,
                            list : null
                        }
                    }
                ],
            },
            {
                name: "helper_text",
                value: {
                  number: null,
                  text: null,
                  list: null,
                  boolean: null
                },
                elements: null,
                component: "text",
                component_params: [
                    {
                        name : "helper_text",
                        value : {
                            text : "Add a helper text",
                            number : null,
                            boolean : null,
                            list : null
                        }
                    },
                    {
                        name : "width",
                        value : {
                            text : null,
                            number : 50,
                            boolean : null,
                            list : null
                        }
                    }
                ],
            },
            {
                name: "multi_line",
                value: {
                  number: null,
                  text: null,
                  list: null,
                  boolean: false
                },
                elements: null,
                component: "switch",
                component_params: [
                    {
                        name : "helper_text",
                        value : {
                            text : "Choose if you want this field to be multiline",
                            number : null,
                            boolean : null,
                            list : null
                        }
                    },
                    {
                        name : "width",
                        value : {
                            text : null,
                            number : 50,
                            boolean : null,
                            list : null
                        }
                    }
                ],
            },
            {
                name: "max_rows",
                value: {
                  number: null,
                  text: null,
                  list: null,
                  boolean: null
                },
                elements: null,
                component: "number",
                component_params: [
                    {
                        name : "helper_text",
                        value : {
                            text : "Number of max rows the textbox will expand.",
                            number : null,
                            boolean : null,
                            list : null
                        }
                    },
                    {
                        name : "width",
                        value : {
                            text : null,
                            number : 50,
                            boolean : null,
                            list : null
                        }
                    }
                ],
            },
            {
                name: "auto_paste",
                value: {
                  number: null,
                  text: null,
                  list: null,
                  boolean: false
                },
                elements: null,
                component: "switch",
                component_params: [
                    {
                        name : "label",
                        value : {
                            text : "Auto Paste from Clipboard",
                            number : null,
                            boolean : null,
                            list : null
                        }
                    },
                    {
                        name : "helper_text",
                        value : {
                            text : "Automatically pastes content from clipboard",
                            number : null,
                            boolean : null,
                            list : null
                        }
                    },
                    {
                        name : "width",
                        value : {
                            text : null,
                            number : 50,
                            boolean : null,
                            list : null
                        }
                    }
                ],
            },
            {
                name: "copy_content",
                value: {
                  number: null,
                  text: null,
                  list: null,
                  boolean: false
                },
                elements: null,
                component: "switch",
                component_params: [
                    {
                        name : "label",
                        value : {
                            text : "Auto copy to Clipboard",
                            number : null,
                            boolean : null,
                            list : null
                        }
                    },
                    {
                        name : "helper_text",
                        value : {
                            text : "Picks up content from this field and copies to clipboard",
                            number : null,
                            boolean : null,
                            list : null
                        }
                    },
                    {
                        name : "width",
                        value : {
                            text : null,
                            number : 50,
                            boolean : null,
                            list : null
                        }
                    }
                ],
            },
            {
                name: "accept_attachment",
                value: {
                  number: null,
                  text: null,
                  list: null,
                  boolean: false
                },
                elements: null,
                component: "switch",
                component_params: [
                    {
                        name : "label",
                        value : {
                            text : "Accept Attachments",
                            number : null,
                            boolean : null,
                            list : null
                        }
                    },
                    {
                        name : "helper_text",
                        value : {
                            text : "Allows user to add attachments to this field.",
                            number : null,
                            boolean : null,
                            list : null
                        }
                    },
                    {
                        name : "width",
                        value : {
                            text : null,
                            number : 50,
                            boolean : null,
                            list : null
                        }
                    }
                ],
            },
            {
                name: "embed_attachment",
                value: {
                  number: null,
                  text: null,
                  list: null,
                  boolean: false
                },
                elements: null,
                component: "switch",
                component_params: [
                    {
                        name : "label",
                        value : {
                            text : "Embed Attachments",
                            number : null,
                            boolean : null,
                            list : null
                        }
                    },
                    {
                        name : "helper_text",
                        value : {
                            text : "Allows user to add inline attachments in the content.",
                            number : null,
                            boolean : null,
                            list : null
                        }
                    },
                    {
                        name : "width",
                        value : {
                            text : null,
                            number : 50,
                            boolean : null,
                            list : null
                        }
                    }
                ],
            }
        ]
    },
    {
        type : "number",
        annotation : "Number Input",
        value_type : "number",
        component_params : [
            {
                name : "place_holder",
                value_type : "text",
                mandatory : false
            },
            {
                name : "error",
                value_type : "boolean",
                mandatory : false
            },
            {
                name : "error_messsage",
                value_type : "text",
                mandatory : false
            },
            {
                name : "helper_text",
                value_type : "text",
                mandatory : false
            },
            {
                name : "mandatory",
                value_type : "boolean",
                mandatory : false
            },
            {
                name : "width",
                value_type : "number",
                mandatory : false
            },
            {
                name : "binding_key",
                value_type : "text",
                mandatory : true
            }
        ],
        setup_form : [
            {
                name : "binding_key",
                value : {
                    number: null,
                    text: null,
                    list: null,
                    boolean: null
                },
                elements: null,
                component: "select",
                component_params : [
                    {
                        name : "width",
                        value : {
                            text : null,
                            number : 50,
                            boolean : null,
                            list : null
                        }
                    },
                    {
                        name: "helper_text",
                        value: {
                            number: null,
                            text: "Select the field in scope you want to bind to.",
                            list: null,
                            boolean: null
                        }
                    },
                    {
                        name : "options",
                        value: {
                            number: null,
                            text: null,
                            list: ["$fieldsInScope"],
                            boolean: null
                        }
                    }
                ]
            },
            {
                name: "width",
                value: {
                  number: 50,
                  text: null,
                  list: null,
                  boolean: null
                },
                elements: null,
                component: "slider",
                component_params: [
                    {
                        name : "width",
                        value : {
                            text : null,
                            number : 50,
                            boolean : null,
                            list : null
                        }
                    },
                    {
                        name: "min_value",
                        value: {
                          number: 0,
                          text: null,
                          list: null,
                          boolean: null
                        }
                    },
                    {
                        name: "max_value",
                        value: {
                          number: 100,
                          text: null,
                          list: null,
                          boolean: null
                        }
                    },
                    {
                        name: "step_size",
                        value: {
                          number: 1,
                          text: null,
                          list: null,
                          boolean: null
                        }
                    }
                ],
            },
            {
                name: "place_holder",
                value: {
                  number: null,
                  text: null,
                  list: null,
                  boolean: null
                },
                elements: null,
                component: "text",
                component_params: [
                    {
                        name : "helper_text",
                        value : {
                            text : "Please add a placeholder",
                            number : null,
                            boolean : null,
                            list : null
                        }
                    },
                    {
                        name : "width",
                        value : {
                            text : null,
                            number : 50,
                            boolean : null,
                            list : null
                        }
                    }
                ],
            },
            {
                name: "helper_text",
                value: {
                  number: null,
                  text: null,
                  list: null,
                  boolean: null
                },
                elements: null,
                component: "text",
                component_params: [
                    {
                        name : "helper_text",
                        value : {
                            text : "Add a helper text",
                            number : null,
                            boolean : null,
                            list : null
                        }
                    },
                    {
                        name : "width",
                        value : {
                            text : null,
                            number : 50,
                            boolean : null,
                            list : null
                        }
                    }
                ],
            },
        ]
    },
    {
        type : "email",
        annotation : "Email Input",
        value_type : "text",
        component_params : [
            {
                name : "place_holder",
                value_type : "text",
                mandatory : false
            },
            {
                name : "error",
                value_type : "boolean",
                mandatory : false
            },
            {
                name : "error_messsage",
                value_type : "text",
                mandatory : false
            },
            {
                name : "helper_text",
                value_type : "text",
                mandatory : false
            },
            {
                name : "mandatory",
                value_type : "boolean",
                mandatory : false
            },
            {
                name : "width",
                value_type : "number",
                mandatory : false
            },
            {
                name : "binding_key",
                value_type : "text",
                mandatory : true
            }
        ],
        setup_form : [
            {
                name : "binding_key",
                value : {
                    number: null,
                    text: null,
                    list: null,
                    boolean: null
                },
                elements: null,
                component: "select",
                component_params : [
                    {
                        name : "width",
                        value : {
                            text : null,
                            number : 50,
                            boolean : null,
                            list : null
                        }
                    },
                    {
                        name: "helper_text",
                        value: {
                            number: null,
                            text: "Select the field in scope you want to bind to.",
                            list: null,
                            boolean: null
                        }
                    },
                    {
                        name : "options",
                        value: {
                            number: null,
                            text: null,
                            list: ["$fieldsInScope"],
                            boolean: null
                        }
                    }
                ]
            },
            {
                name: "width",
                value: {
                  number: 50,
                  text: null,
                  list: null,
                  boolean: null
                },
                elements: null,
                component: "slider",
                component_params: [
                    {
                        name : "width",
                        value : {
                            text : null,
                            number : 50,
                            boolean : null,
                            list : null
                        }
                    },
                    {
                        name: "min_value",
                        value: {
                          number: 0,
                          text: null,
                          list: null,
                          boolean: null
                        }
                    },
                    {
                        name: "max_value",
                        value: {
                          number: 100,
                          text: null,
                          list: null,
                          boolean: null
                        }
                    },
                    {
                        name: "step_size",
                        value: {
                          number: 1,
                          text: null,
                          list: null,
                          boolean: null
                        }
                    }
                ],
            },
            {
                name: "place_holder",
                value: {
                  number: null,
                  text: null,
                  list: null,
                  boolean: null
                },
                elements: null,
                component: "text",
                component_params: [
                    {
                        name : "helper_text",
                        value : {
                            text : "Please add a placeholder",
                            number : null,
                            boolean : null,
                            list : null
                        }
                    },
                    {
                        name : "width",
                        value : {
                            text : null,
                            number : 50,
                            boolean : null,
                            list : null
                        }
                    }
                ],
            },
            {
                name: "helper_text",
                value: {
                  number: null,
                  text: null,
                  list: null,
                  boolean: null
                },
                elements: null,
                component: "text",
                component_params: [
                    {
                        name : "helper_text",
                        value : {
                            text : "Add a helper text",
                            number : null,
                            boolean : null,
                            list : null
                        }
                    },
                    {
                        name : "width",
                        value : {
                            text : null,
                            number : 50,
                            boolean : null,
                            list : null
                        }
                    }
                ],
            },
        ]
    },
    {
        type : "password",
        annotation : "Password Input",
        value_type : "text",
        component_params : [
            {
                name : "place_holder",
                value_type : "text",
                mandatory : false
            },
            {
                name : "error",
                value_type : "boolean",
                mandatory : false
            },
            {
                name : "error_messsage",
                value_type : "text",
                mandatory : false
            },
            {
                name : "helper_text",
                value_type : "text",
                mandatory : false
            },
            {
                name : "mandatory",
                value_type : "boolean",
                mandatory : false
            },
            {
                name : "width",
                value_type : "number",
                mandatory : false
            },
            {
                name : "binding_key",
                value_type : "text",
                mandatory : true
            }
        ],
        setup_form : [
            {
                name : "binding_key",
                value : {
                    number: null,
                    text: null,
                    list: null,
                    boolean: null
                },
                elements: null,
                component: "select",
                component_params : [
                    {
                        name : "width",
                        value : {
                            text : null,
                            number : 50,
                            boolean : null,
                            list : null
                        }
                    },
                    {
                        name: "helper_text",
                        value: {
                            number: null,
                            text: "Select the field in scope you want to bind to.",
                            list: null,
                            boolean: null
                        }
                    },
                    {
                        name : "options",
                        value: {
                            number: null,
                            text: null,
                            list: ["$fieldsInScope"],
                            boolean: null
                        }
                    }
                ]
            },
            {
                name: "width",
                value: {
                  number: 50,
                  text: null,
                  list: null,
                  boolean: null
                },
                elements: null,
                component: "slider",
                component_params: [
                    {
                        name : "width",
                        value : {
                            text : null,
                            number : 50,
                            boolean : null,
                            list : null
                        }
                    },
                    {
                        name: "min_value",
                        value: {
                          number: 0,
                          text: null,
                          list: null,
                          boolean: null
                        }
                    },
                    {
                        name: "max_value",
                        value: {
                          number: 100,
                          text: null,
                          list: null,
                          boolean: null
                        }
                    },
                    {
                        name: "step_size",
                        value: {
                          number: 1,
                          text: null,
                          list: null,
                          boolean: null
                        }
                    }
                ],
            },
            {
                name: "place_holder",
                value: {
                  number: null,
                  text: null,
                  list: null,
                  boolean: null
                },
                elements: null,
                component: "text",
                component_params: [
                    {
                        name : "helper_text",
                        value : {
                            text : "Please add a placeholder",
                            number : null,
                            boolean : null,
                            list : null
                        }
                    },
                    {
                        name : "width",
                        value : {
                            text : null,
                            number : 50,
                            boolean : null,
                            list : null
                        }
                    }
                ],
            },
            {
                name: "helper_text",
                value: {
                  number: null,
                  text: null,
                  list: null,
                  boolean: null
                },
                elements: null,
                component: "text",
                component_params: [
                    {
                        name : "helper_text",
                        value : {
                            text : "Add a helper text",
                            number : null,
                            boolean : null,
                            list : null
                        }
                    },
                    {
                        name : "width",
                        value : {
                            text : null,
                            number : 50,
                            boolean : null,
                            list : null
                        }
                    }
                ],
            },
        ]
    },
    {
        type : "url",
        annotation : "URL Input",
        value_type : "text",
        component_params : [
            {
                name : "place_holder",
                value_type : "text",
                mandatory : false
            },
            {
                name : "error",
                value_type : "boolean",
                mandatory : false
            },
            {
                name : "error_messsage",
                value_type : "text",
                mandatory : false
            },
            {
                name : "helper_text",
                value_type : "text",
                mandatory : false
            },
            {
                name : "mandatory",
                value_type : "boolean",
                mandatory : false
            },
            {
                name : "width",
                value_type : "number",
                mandatory : false
            },
            {
                name : "binding_key",
                value_type : "text",
                mandatory : true
            }
        ],
        setup_form : [
            {
                name : "binding_key",
                value : {
                    number: null,
                    text: null,
                    list: null,
                    boolean: null
                },
                elements: null,
                component: "select",
                component_params : [
                    {
                        name : "width",
                        value : {
                            text : null,
                            number : 50,
                            boolean : null,
                            list : null
                        }
                    },
                    {
                        name: "helper_text",
                        value: {
                            number: null,
                            text: "Select the field in scope you want to bind to.",
                            list: null,
                            boolean: null
                        }
                    },
                    {
                        name : "options",
                        value: {
                            number: null,
                            text: null,
                            list: ["$fieldsInScope"],
                            boolean: null
                        }
                    }
                ]
            },
            {
                name: "width",
                value: {
                  number: 50,
                  text: null,
                  list: null,
                  boolean: null
                },
                elements: null,
                component: "slider",
                component_params: [
                    {
                        name : "width",
                        value : {
                            text : null,
                            number : 50,
                            boolean : null,
                            list : null
                        }
                    },
                    {
                        name: "min_value",
                        value: {
                          number: 0,
                          text: null,
                          list: null,
                          boolean: null
                        }
                    },
                    {
                        name: "max_value",
                        value: {
                          number: 100,
                          text: null,
                          list: null,
                          boolean: null
                        }
                    },
                    {
                        name: "step_size",
                        value: {
                          number: 1,
                          text: null,
                          list: null,
                          boolean: null
                        }
                    }
                ],
            },
            {
                name: "place_holder",
                value: {
                  number: null,
                  text: null,
                  list: null,
                  boolean: null
                },
                elements: null,
                component: "text",
                component_params: [
                    {
                        name : "helper_text",
                        value : {
                            text : "Please add a placeholder",
                            number : null,
                            boolean : null,
                            list : null
                        }
                    },
                    {
                        name : "width",
                        value : {
                            text : null,
                            number : 50,
                            boolean : null,
                            list : null
                        }
                    }
                ],
            },
            {
                name: "helper_text",
                value: {
                  number: null,
                  text: null,
                  list: null,
                  boolean: null
                },
                elements: null,
                component: "text",
                component_params: [
                    {
                        name : "helper_text",
                        value : {
                            text : "Add a helper text",
                            number : null,
                            boolean : null,
                            list : null
                        }
                    },
                    {
                        name : "width",
                        value : {
                            text : null,
                            number : 50,
                            boolean : null,
                            list : null
                        }
                    }
                ],
            },
        ]
    },
    {
        type : "select",
        annotation : "Dropdown",
        value_type : "text",
        component_params : [
            {
                name : "error",
                value_type : "boolean",
                mandatory : false
            },
            {
                name : "error_messsage",
                value_type : "text",
                mandatory : false
            },
            {
                name : "helper_text",
                value_type : "text",
                mandatory : false
            },
            {
                name : "mandatory",
                value_type : "boolean",
                mandatory : false
            },
            {
                name : "width",
                value_type : "number",
                mandatory : false
            },
            {
                name : "label",
                value_type : "text",
                mandatory : true
            },
            {
                name : "options",
                value_type : "list",
                mandatory : true
            },
            {
                name : "binding_key",
                value_type : "text",
                mandatory : true
            }
        ],
        setup_form : [
            {
                name : "binding_key",
                value : {
                    number: null,
                    text: null,
                    list: null,
                    boolean: null
                },
                elements: null,
                component: "select",
                component_params : [
                    {
                        name : "width",
                        value : {
                            text : null,
                            number : 50,
                            boolean : null,
                            list : null
                        }
                    },
                    {
                        name: "helper_text",
                        value: {
                            number: null,
                            text: "Select the field in scope you want to bind to.",
                            list: null,
                            boolean: null
                        }
                    },
                    {
                        name : "options",
                        value: {
                            number: null,
                            text: null,
                            list: ["$fieldsInScope"],
                            boolean: null
                        }
                    }
                ]
            },
            {
                name: "width",
                value: {
                  number: 50,
                  text: null,
                  list: null,
                  boolean: null
                },
                elements: null,
                component: "slider",
                component_params: [
                    {
                        name : "width",
                        value : {
                            text : null,
                            number : 50,
                            boolean : null,
                            list : null
                        }
                    },
                    {
                        name: "min_value",
                        value: {
                          number: 0,
                          text: null,
                          list: null,
                          boolean: null
                        }
                    },
                    {
                        name: "max_value",
                        value: {
                          number: 100,
                          text: null,
                          list: null,
                          boolean: null
                        }
                    },
                    {
                        name: "step_size",
                        value: {
                          number: 1,
                          text: null,
                          list: null,
                          boolean: null
                        }
                    }
                ],
            },
            {
                name: "helper_text",
                value: {
                  number: null,
                  text: null,
                  list: null,
                  boolean: null
                },
                elements: null,
                component: "text",
                component_params: [
                    {
                        name : "helper_text",
                        value : {
                            text : "Add a helper text",
                            number : null,
                            boolean : null,
                            list : null
                        }
                    },
                    {
                        name : "width",
                        value : {
                            text : null,
                            number : 50,
                            boolean : null,
                            list : null
                        }
                    }
                ],
            },
            {
                name : "options",
                value: {
                    number: null,
                    text: null,
                    list: null,
                    boolean: null
                },
                component: "group",
                elements: [
                    [
                        {
                            name : "value",
                            component : "text",
                            elements : null,
                            component_params: [
                                {
                                    name : "helper_text",
                                    value : {
                                        text : "Add a helper text",
                                        number : null,
                                        boolean : null,
                                        list : null
                                    }
                                },
                                {
                                    name : "width",
                                    value : {
                                        text : null,
                                        number : 50,
                                        boolean : null,
                                        list : null
                                    }
                                }
                            ],
                            value: {
                                number: null,
                                text: null,
                                list: null,
                                boolean: null
                            }
                        },
                        {
                            name : "annotation",
                            component : "text",
                            elements : null,
                            component_params: [
                                {
                                    name : "helper_text",
                                    value : {
                                        text : "Add a helper text",
                                        number : null,
                                        boolean : null,
                                        list : null
                                    }
                                },
                                {
                                    name : "width",
                                    value : {
                                        text : null,
                                        number : 50,
                                        boolean : null,
                                        list : null
                                    }
                                }
                            ],
                            value: {
                                number: null,
                                text: null,
                                list: null,
                                boolean: null
                            }
                        }
                    ]
                ],
                component_params : []
            }
        ]
    },
    {
        type : "multi_select",
        annotation : "Multi Select Dropdown",
        value_type : "list",
        component_params : [
            {
                name : "error",
                value_type : "boolean",
                mandatory : false
            },
            {
                name : "error_messsage",
                value_type : "text",
                mandatory : false
            },
            {
                name : "helper_text",
                value_type : "text",
                mandatory : false
            },
            {
                name : "mandatory",
                value_type : "boolean",
                mandatory : false
            },
            {
                name : "width",
                value_type : "number",
                mandatory : false
            },
            {
                name : "label",
                value_type : "text",
                mandatory : true
            },
            {
                name : "options",
                value_type : "list",
                mandatory : true
            },
            {
                name : "binding_key",
                value_type : "text",
                mandatory : true
            }
        ],
        setup_form : [
            {
                name : "binding_key",
                value : {
                    number: null,
                    text: null,
                    list: null,
                    boolean: null
                },
                elements: null,
                component: "select",
                component_params : [
                    {
                        name : "width",
                        value : {
                            text : null,
                            number : 50,
                            boolean : null,
                            list : null
                        }
                    },
                    {
                        name: "helper_text",
                        value: {
                            number: null,
                            text: "Select the field in scope you want to bind to.",
                            list: null,
                            boolean: null
                        }
                    },
                    {
                        name : "options",
                        value: {
                            number: null,
                            text: null,
                            list: ["$fieldsInScope"],
                            boolean: null
                        }
                    }
                ]
            },
            {
                name: "width",
                value: {
                  number: 50,
                  text: null,
                  list: null,
                  boolean: null
                },
                elements: null,
                component: "slider",
                component_params: [
                    {
                        name : "width",
                        value : {
                            text : null,
                            number : 50,
                            boolean : null,
                            list : null
                        }
                    },
                    {
                        name: "min_value",
                        value: {
                          number: 0,
                          text: null,
                          list: null,
                          boolean: null
                        }
                    },
                    {
                        name: "max_value",
                        value: {
                          number: 100,
                          text: null,
                          list: null,
                          boolean: null
                        }
                    },
                    {
                        name: "step_size",
                        value: {
                          number: 1,
                          text: null,
                          list: null,
                          boolean: null
                        }
                    }
                ],
            },
            {
                name: "helper_text",
                value: {
                  number: null,
                  text: null,
                  list: null,
                  boolean: null
                },
                elements: null,
                component: "text",
                component_params: [
                    {
                        name : "helper_text",
                        value : {
                            text : "Add a helper text",
                            number : null,
                            boolean : null,
                            list : null
                        }
                    },
                    {
                        name : "width",
                        value : {
                            text : null,
                            number : 50,
                            boolean : null,
                            list : null
                        }
                    }
                ],
            },
            {
                name : "options",
                value: {
                    number: null,
                    text: null,
                    list: null,
                    boolean: null
                },
                component: "group",
                elements: [
                    [
                        {
                            name : "value",
                            component : "text",
                            elements : null,
                            component_params: [
                                {
                                    name : "helper_text",
                                    value : {
                                        text : "Add a helper text",
                                        number : null,
                                        boolean : null,
                                        list : null
                                    }
                                },
                                {
                                    name : "width",
                                    value : {
                                        text : null,
                                        number : 50,
                                        boolean : null,
                                        list : null
                                    }
                                }
                            ],
                            value: {
                                number: null,
                                text: null,
                                list: null,
                                boolean: null
                            }
                        },
                        {
                            name : "annotation",
                            component : "text",
                            elements : null,
                            component_params: [
                                {
                                    name : "helper_text",
                                    value : {
                                        text : "Add a helper text",
                                        number : null,
                                        boolean : null,
                                        list : null
                                    }
                                },
                                {
                                    name : "width",
                                    value : {
                                        text : null,
                                        number : 50,
                                        boolean : null,
                                        list : null
                                    }
                                }
                            ],
                            value: {
                                number: null,
                                text: null,
                                list: null,
                                boolean: null
                            }
                        }
                    ]
                ],
                component_params : []
            }
        ]
    },
    {
        type : "slider",
        annotation : "Slider",
        value_type : "number",
        component_params : [
            {
                name : "min_value",
                value_type : "number",
                mandatory : true
            },
            {
                name : "max_value",
                value_type : "number",
                mandatory : true
            },
            {
                name : "step_size",
                value_type : "number",
                mandatory : true
            },
            {
                name : "error",
                value_type : "boolean",
                mandatory : false
            },
            {
                name : "error_messsage",
                value_type : "text",
                mandatory : false
            },
            {
                name : "helper_text",
                value_type : "text",
                mandatory : false
            },
            {
                name : "width",
                value_type : "number",
                mandatory : false
            },
            {
                name : "binding_key",
                value_type : "text",
                mandatory : true
            }
        ],
        setup_form : [
            {
                name : "binding_key",
                value : {
                    number: null,
                    text: null,
                    list: null,
                    boolean: null
                },
                elements: null,
                component: "select",
                component_params : [
                    {
                        name : "width",
                        value : {
                            text : null,
                            number : 50,
                            boolean : null,
                            list : null
                        }
                    },
                    {
                        name: "helper_text",
                        value: {
                            number: null,
                            text: "Select the field in scope you want to bind to.",
                            list: null,
                            boolean: null
                        }
                    },
                    {
                        name : "options",
                        value: {
                            number: null,
                            text: null,
                            list: ["$fieldsInScope"],
                            boolean: null
                        }
                    }
                ]
            },
            {
                name: "width",
                value: {
                  number: 50,
                  text: null,
                  list: null,
                  boolean: null
                },
                elements: null,
                component: "slider",
                component_params: [
                    {
                        name : "width",
                        value : {
                            text : null,
                            number : 50,
                            boolean : null,
                            list : null
                        }
                    },
                    {
                        name: "min_value",
                        value: {
                          number: 0,
                          text: null,
                          list: null,
                          boolean: null
                        }
                    },
                    {
                        name: "max_value",
                        value: {
                          number: 100,
                          text: null,
                          list: null,
                          boolean: null
                        }
                    },
                    {
                        name: "step_size",
                        value: {
                          number: 1,
                          text: null,
                          list: null,
                          boolean: null
                        }
                    }
                ],
            },
            {
                name: "min_value",
                value: {
                  number: null,
                  text: null,
                  list: null,
                  boolean: null
                },
                elements: null,
                component: "number",
                component_params: [
                    {
                        name : "helper_text",
                        value : {
                            text : "Minimum Value",
                            number : null,
                            boolean : null,
                            list : null
                        }
                    },
                    {
                        name : "width",
                        value : {
                            text : null,
                            number : 50,
                            boolean : null,
                            list : null
                        }
                    }
                ],
            },
            {
                name: "max_value",
                value: {
                  number: null,
                  text: null,
                  list: null,
                  boolean: null
                },
                elements: null,
                component: "number",
                component_params: [
                    {
                        name : "helper_text",
                        value : {
                            text : "Maximum Value",
                            number : null,
                            boolean : null,
                            list : null
                        }
                    },
                    {
                        name : "width",
                        value : {
                            text : null,
                            number : 50,
                            boolean : null,
                            list : null
                        }
                    }
                ],
            },
            {
                name: "step_size",
                value: {
                  number: null,
                  text: null,
                  list: null,
                  boolean: null
                },
                elements: null,
                component: "number",
                component_params: [
                    {
                        name : "helper_text",
                        value : {
                            text : "Step Size",
                            number : null,
                            boolean : null,
                            list : null
                        }
                    },
                    {
                        name : "width",
                        value : {
                            text : null,
                            number : 50,
                            boolean : null,
                            list : null
                        }
                    }
                ],
            }
        ]
    },
    {
        type : "switch",
        annotation : "Switch",
        value_type : "boolean",
        component_params : [
            {
                name : "helper_text",
                value_type : "text",
                mandatory : false
            },
            {
                name : "mandatory",
                value_type : "boolean",
                mandatory : false
            },
            {
                name : "width",
                value_type : "number",
                mandatory : false
            },
            {
                name : "binding_key",
                value_type : "text",
                mandatory : true
            }
        ],
        setup_form : [
            {
                name : "binding_key",
                value : {
                    number: null,
                    text: null,
                    list: null,
                    boolean: null
                },
                elements: null,
                component: "select",
                component_params : [
                    {
                        name : "width",
                        value : {
                            text : null,
                            number : 50,
                            boolean : null,
                            list : null
                        }
                    },
                    {
                        name: "helper_text",
                        value: {
                            number: null,
                            text: "Select the field in scope you want to bind to.",
                            list: null,
                            boolean: null
                        }
                    },
                    {
                        name : "options",
                        value: {
                            number: null,
                            text: null,
                            list: ["$fieldsInScope"],
                            boolean: null
                        }
                    }
                ]
            },
            {
                name: "width",
                value: {
                  number: 50,
                  text: null,
                  list: null,
                  boolean: null
                },
                elements: null,
                component: "slider",
                component_params: [
                    {
                        name : "width",
                        value : {
                            text : null,
                            number : 50,
                            boolean : null,
                            list : null
                        }
                    },
                    {
                        name: "min_value",
                        value: {
                          number: 0,
                          text: null,
                          list: null,
                          boolean: null
                        }
                    },
                    {
                        name: "max_value",
                        value: {
                          number: 100,
                          text: null,
                          list: null,
                          boolean: null
                        }
                    },
                    {
                        name: "step_size",
                        value: {
                          number: 1,
                          text: null,
                          list: null,
                          boolean: null
                        }
                    }
                ],
            }
        ]
    },
    {
        type : "display_card",
        annotation : "Display Card",
        value_type : "text",
        component_params : [
            {
                name : "label",
                value_type : "text",
                mandatory : false
            },
            {
                name : "width",
                value_type : "number",
                mandatory : false
            },
            {
                name : "accept_attachment",
                value_type : "boolean",
                mandatory : false
            },
            {
                name : "embed_attachment",
                value_type : "boolean",
                mandatory : false
            },
            {
                name : "binding_key",
                value_type : "text",
                mandatory : true
            }
        ],
        setup_form : [
            {
                name : "binding_key",
                value : {
                    number: null,
                    text: null,
                    list: null,
                    boolean: null
                },
                elements: null,
                component: "select",
                component_params : [
                    {
                        name : "width",
                        value : {
                            text : null,
                            number : 50,
                            boolean : null,
                            list : null
                        }
                    },
                    {
                        name: "helper_text",
                        value: {
                            number: null,
                            text: "Select the field in scope you want to bind to.",
                            list: null,
                            boolean: null
                        }
                    },
                    {
                        name : "options",
                        value: {
                            number: null,
                            text: null,
                            list: ["$fieldsInScope"],
                            boolean: null
                        }
                    }
                ]
            },
            {
                name: "width",
                value: {
                  number: 50,
                  text: null,
                  list: null,
                  boolean: null
                },
                elements: null,
                component: "slider",
                component_params: [
                    {
                        name : "width",
                        value : {
                            text : null,
                            number : 50,
                            boolean : null,
                            list : null
                        }
                    },
                    {
                        name: "min_value",
                        value: {
                          number: 0,
                          text: null,
                          list: null,
                          boolean: null
                        }
                    },
                    {
                        name: "max_value",
                        value: {
                          number: 100,
                          text: null,
                          list: null,
                          boolean: null
                        }
                    },
                    {
                        name: "step_size",
                        value: {
                          number: 1,
                          text: null,
                          list: null,
                          boolean: null
                        }
                    }
                ],
            },
            {
                name: "label",
                value: {
                  number: null,
                  text: null,
                  list: null,
                  boolean: null
                },
                elements: null,
                component: "text",
                component_params: [
                    {
                        name : "helper_text",
                        value : {
                            text : "Please add a label",
                            number : null,
                            boolean : null,
                            list : null
                        }
                    },
                    {
                        name : "width",
                        value : {
                            text : null,
                            number : 50,
                            boolean : null,
                            list : null
                        }
                    }
                ],
            },
            {
                name: "accept_attachment",
                value: {
                  number: null,
                  text: null,
                  list: null,
                  boolean: false
                },
                elements: null,
                component: "switch",
                component_params: [
                    {
                        name : "label",
                        value : {
                            text : "Accept Attachments",
                            number : null,
                            boolean : null,
                            list : null
                        }
                    },
                    {
                        name : "helper_text",
                        value : {
                            text : "Allows user to add attachments to this field.",
                            number : null,
                            boolean : null,
                            list : null
                        }
                    },
                    {
                        name : "width",
                        value : {
                            text : null,
                            number : 50,
                            boolean : null,
                            list : null
                        }
                    }
                ],
            },
            {
                name: "embed_attachment",
                value: {
                  number: null,
                  text: null,
                  list: null,
                  boolean: false
                },
                elements: null,
                component: "switch",
                component_params: [
                    {
                        name : "label",
                        value : {
                            text : "Embed Attachments",
                            number : null,
                            boolean : null,
                            list : null
                        }
                    },
                    {
                        name : "helper_text",
                        value : {
                            text : "Allows user to add inline attachments in the content.",
                            number : null,
                            boolean : null,
                            list : null
                        }
                    },
                    {
                        name : "width",
                        value : {
                            text : null,
                            number : 50,
                            boolean : null,
                            list : null
                        }
                    }
                ],
            }
        ]
    },
    {
        type : "display_long_text",
        annotation : "Display Long text",
        value_type : "text",
        component_params : [
            {
                name : "label",
                value_type : "text",
                mandatory : false
            },
            {
                name : "accept_attachment",
                value_type : "boolean",
                mandatory : false
            },
            {
                name : "embed_attachment",
                value_type : "boolean",
                mandatory : false
            },
            {
                name : "binding_key",
                value_type : "text",
                mandatory : true
            },
            {
                name : "width",
                value_type : "number",
                mandatory : false
            }
        ],
        setup_form : [
            {
                name : "binding_key",
                value : {
                    number: null,
                    text: null,
                    list: null,
                    boolean: null
                },
                elements: null,
                component: "select",
                component_params : [
                    {
                        name : "width",
                        value : {
                            text : null,
                            number : 50,
                            boolean : null,
                            list : null
                        }
                    },
                    {
                        name: "helper_text",
                        value: {
                            number: null,
                            text: "Select the field in scope you want to bind to.",
                            list: null,
                            boolean: null
                        }
                    },
                    {
                        name : "options",
                        value: {
                            number: null,
                            text: null,
                            list: ["$fieldsInScope"],
                            boolean: null
                        }
                    }
                ]
            },
            {
                name: "width",
                value: {
                  number: 50,
                  text: null,
                  list: null,
                  boolean: null
                },
                elements: null,
                component: "slider",
                component_params: [
                    {
                        name : "width",
                        value : {
                            text : null,
                            number : 50,
                            boolean : null,
                            list : null
                        }
                    },
                    {
                        name: "min_value",
                        value: {
                          number: 0,
                          text: null,
                          list: null,
                          boolean: null
                        }
                    },
                    {
                        name: "max_value",
                        value: {
                          number: 100,
                          text: null,
                          list: null,
                          boolean: null
                        }
                    },
                    {
                        name: "step_size",
                        value: {
                          number: 1,
                          text: null,
                          list: null,
                          boolean: null
                        }
                    }
                ],
            },
            {
                name: "label",
                value: {
                  number: null,
                  text: null,
                  list: null,
                  boolean: null
                },
                elements: null,
                component: "text",
                component_params: [
                    {
                        name : "helper_text",
                        value : {
                            text : "Please add a label",
                            number : null,
                            boolean : null,
                            list : null
                        }
                    },
                    {
                        name : "width",
                        value : {
                            text : null,
                            number : 50,
                            boolean : null,
                            list : null
                        }
                    }
                ],
            },
            {
                name: "accept_attachment",
                value: {
                  number: null,
                  text: null,
                  list: null,
                  boolean: false
                },
                elements: null,
                component: "switch",
                component_params: [
                    {
                        name : "label",
                        value : {
                            text : "Accept Attachments",
                            number : null,
                            boolean : null,
                            list : null
                        }
                    },
                    {
                        name : "helper_text",
                        value : {
                            text : "Allows user to add attachments to this field.",
                            number : null,
                            boolean : null,
                            list : null
                        }
                    },
                    {
                        name : "width",
                        value : {
                            text : null,
                            number : 50,
                            boolean : null,
                            list : null
                        }
                    }
                ],
            },
            {
                name: "embed_attachment",
                value: {
                  number: null,
                  text: null,
                  list: null,
                  boolean: false
                },
                elements: null,
                component: "switch",
                component_params: [
                    {
                        name : "label",
                        value : {
                            text : "Embed Attachments",
                            number : null,
                            boolean : null,
                            list : null
                        }
                    },
                    {
                        name : "helper_text",
                        value : {
                            text : "Allows user to add inline attachments in the content.",
                            number : null,
                            boolean : null,
                            list : null
                        }
                    },
                    {
                        name : "width",
                        value : {
                            text : null,
                            number : 50,
                            boolean : null,
                            list : null
                        }
                    }
                ],
            }
        ]
    },
    {
        type : "group",
        annotation : "Group",
        value_type : "list",
        component_params : [],
        setup_form : []
    }
]

export default components